document.addEventListener("DOMContentLoaded", function () {
  var dropdown = document.getElementById("location-code");
  if (!dropdown) return;


  addPlaceholder();
  syncCheckoutState();

  if (typeof jsonUrl === "undefined") {
    return;
  }

  var clientTagsArray = typeof clientTags !== "undefined" && clientTags ? clientTags.split(",") : [];

  fetch(jsonUrl)
    .then(function (response) {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(function (data) {
      clientTagsArray.forEach(function (tag) {
        if (data[tag]) {
          data[tag].addresses.forEach(function (address) {
            var optionElement = document.createElement("option");
            optionElement.value = address.address_name;
            optionElement.text = address.address_name + " - " + buildLabel(address);
            dropdown.add(optionElement);
          });
        }
      });

      var otherOptionElement = document.createElement("option");
      otherOptionElement.value = "OTHER";
      otherOptionElement.text = "OTHER";
      dropdown.add(otherOptionElement);

      dropdown.value = "";
      syncCheckoutState();
    })
    .catch(function (error) {
      console.error("Error loading JSON data:", error);
      syncCheckoutState();
    });

  dropdown.addEventListener("change", syncCheckoutState);

  var poField = document.getElementById("purchase-order-number-if-required");
  if (poField) {
    poField.addEventListener("input", syncCheckoutState);
  }

  var cartForm = document.getElementById("cart-form");
  if (cartForm) {
    cartForm.addEventListener("submit", function (e) {
      if (document.activeElement && document.activeElement.name === "update") return;
      if (!isValid()) {
        e.preventDefault();
        alert("Please select a Location Code and enter a P.O. Number before checking out.");
      }
    });
  }

  function addPlaceholder() {
    if (dropdown.querySelector("option[data-placeholder]")) return;
    var placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.text = "Select a location code";
    placeholder.setAttribute("data-placeholder", "");
    dropdown.insertBefore(placeholder, dropdown.firstChild);
  }

  function isValid() {
    var locationOk = dropdown.value !== "";
    var poOk = !poField || poField.value.trim() !== "";
    return locationOk && poOk;
  }

  function syncCheckoutState() {
    var checkoutButton = document.querySelector('input[name="checkout"]');
    if (!checkoutButton) return;
    var ok = isValid();
    checkoutButton.disabled = !ok;
    checkoutButton.style.opacity = ok ? "" : "0.5";
    checkoutButton.style.cursor = ok ? "" : "not-allowed";
  }

  function buildLabel(address) {
    return address.street + ", " + address.city + ", " + address.state + " " + address.zip_code;
  }
});